import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TenantConfigRes } from 'app/components/models/tenant';
import { fadeInAnimation } from 'app/core/route-animation/route.animation';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { ConfigDataService } from 'app/services/config.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'ms-list-config',
  templateUrl: './list-config.component.html',
  styleUrls: ['./list-config.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    "[@fadeInAnimation]": 'true'
  },
  animations: [fadeInAnimation]
})
export class ListConfigComponent implements OnInit, AfterViewInit {

  @ViewChild('createDateTpl') createDateTpl: TemplateRef<any>;
  @ViewChild('actionCellTpl') actionCellTpl: TemplateRef<any>;

  submitted = false;
  error = false;
  success = false;
  data: any;
  configList: TenantConfigRes[] = [];
  rows = [];
  columns = [];
  excelRows = [];

  defaultSort = [
    {
      prop: 'created',
      dir: 'desc'
    }
  ];

  header: string[] = [];

  constructor(
    private router: Router,
    private commonUtilService: CommonUtilService,
    private configService: ConfigDataService,
    private spinnerService: SpinnerService,
    private datePipe: DatePipe) { }


  ngOnInit(): void {

    this.spinnerService.start();

    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.TENANT_LIST");

    this.configService.getConfigList().subscribe(data => {
      this.rows = data;
      this.spinnerService.stop();
    });

  }

  ngAfterViewInit(): void {

    this.columns = [
      { name: 'Tenant Nome', prop: 'name' },
      { name: 'DNS', prop: 'dns' },
      { name: 'Business Plan', prop: 'businessPlan' },
      { name: 'Date created', cellTemplate: this.createDateTpl },
      { name: 'Actions', sortable: false, cellTemplate: this.actionCellTpl }
    ];

  }

  goToTenantDetail(id) {
    this.spinnerService.start();
    this.router.navigate([`tenant/manage-tenant/${id}`]);
  }

  addTenant() {
    this.spinnerService.start();
    this.router.navigate([`tenant/create-tenant`]);
  }

  exportToExcel(): void {

    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsExcel('Tenants', this.excelRows, "Elenco degli tenant - HRWE.xlsx");

    this.spinnerService.stop();

  }

  exportToPDF(): void {
    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsPDF(false, this.header, this.excelRows, "Elenco degli tenant - HRWE.pdf");
    
  }

  exportRows() {

    this.header = ['Tenant Nome', 'DNS', 'Business Plan', 'Date created'];

    let arr = this.rows.map(row => {
      return {
        'Tenant Nome': row.name,
        'DNS': row.dns,
        'Business Plan': row.businessPlan,
        'Date created': this.datePipe.transform(row.created, 'dd/MM/yyyy'),
      }
    });

    return arr;
  }

}
